module.exports = "<div fxFill fxLayout=\"column\">\r\n    <div fxFlex=\"initial\">\r\n        <nav-menu></nav-menu>\r\n    </div>\r\n    <div fxFlex>\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/app/app.component.html
// module id = ../../../../../src/app/app/app.component.html
// module chunks = 1